import {FC, memo} from 'react'
import isEmpty from 'lodash/isEmpty'
import classnames from 'classnames'
import './CardProduct.css'

import { FiChevronRight } from 'react-icons/fi'
import { Product } from "../../api/types"

const CardProductComponent: FC<{
  product: Product
}> = ({ product }) => {
  const isImageAvailable = !isEmpty(product.images)
  const hasSubtitle = Boolean(product.subtitle)
  const displayOldPrice = Boolean(((product.price ?? "") + (product.oldPrice ?? "")).length <= 16)
  return (
    <div className={'card-product-container'}>
      {isImageAvailable && (
        <div className="card-product-image">
          <img alt="product image" src={product.images[0]} />
        </div>
      )}
      <div
        className={classnames('card-product-area-main', {
          'has-image': isImageAvailable,
          'has-subtitle': hasSubtitle,
        })}
      >
        <div className="card-product-header">
          <div className={'card-product-title'}>{product.title}</div>
          {hasSubtitle && (
            <div className={'card-product-subtitle'}>{product.subtitle}</div>
          )}
        </div>

          { product.price && product.price !== "" && (
              <div className={'card-product-price-container'}>
                  {product.price && product.oldPrice && displayOldPrice ? (
                      <>
                          <span className={'card-product-oldprice'}>
                            {product.oldPrice}
                          </span>
                          <span className={'card-product-price'}>{product.price}</span>
                      </>
                  ) : (
                      product.price && (
                          <>
                              <span className={'card-product-price'}>{product.price}</span>
                          </>
                      )
                  )}
              </div>
          )}

      </div>
      <div className={'card-product-area-right'}>
        <FiChevronRight />
      </div>
    </div>
  )
}

export const CardProduct = memo(CardProductComponent)
